import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { HeaderComponent } from '@app/public/header/header.component';
import { HeroComponent } from '@app/public/hero/hero.component';
import { WhyUsComponent } from '@app/public/why-us/why-us.component';
import { HowItWorksComponent } from '@app/public/how-it-works/how-it-works.component';
import { TestimonialsComponent } from '@app/public/testimonials/testimonials.component';
import { CtaComponent } from '@app/public/cta/cta.component';
import { FooterComponent } from '@app/public/footer/footer.component';
import { CookieConsentComponent } from '../cookie-consent.component';
import { ContactUsComponent } from '@app/public/contact-us/contact-us.component';
import { DownloadAppComponent } from '@app/public/download-app/download-app.component';

@Component({
  selector: 'zero-waste-vitrine',
  standalone: true,
  imports: [
    HeaderComponent,
    HeroComponent,
    WhyUsComponent,
    HowItWorksComponent,
    TestimonialsComponent,
    CtaComponent,
    FooterComponent,
    CookieConsentComponent,
    ContactUsComponent,
    DownloadAppComponent,
  ],
  templateUrl: './vitrine.component.html',
  styleUrl: './vitrine.component.scss',
})
export class VitrineComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    // Gérer le fragment d'URL pour le scroll automatique
    this.route.fragment.subscribe((fragment) => {
      if (fragment === 'contact-us') {
        // Attendre que la page soit complètement chargée
        setTimeout(() => {
          const element = document.getElementById('contact-us');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 500);
      }
    });
  }
}
